//#region src/locales/ja/tamagotchi/settings.yaml
var data = {
	"allow-visible-on-all-workspaces": {
		"title": "すべてのワークスペースで表示",
		"description": "ウィンドウをすべてのワークスペースで表示可能にします。macOSのみ。"
	},
	"spotlight": { "errors": {
		"unknown": "不明なエラー",
		"prefix": "問題が発生しました: {message}",
		"shortcutRegistrationFailed": "問題が発生しました: Spotlight ショートカットを登録できませんでした。"
	} },
	"pages": {
		"modules": { "mcp-server": {
			"description": "MCPサーバーとツールの接続と管理",
			"title": "MCPサーバー"
		} },
		"system": {
			"sections": { "section": { "window-shortcuts": { "title": "キーボードショートカット" } } },
			"window-shortcuts": {
				"description": "ウィンドウ用ショートカットを変更します。",
				"title": "ウィンドウショートカット",
				"empty": "未設定",
				"spotlight": {
					"title": "Spotlight ショートカット",
					"description": "ショートカットをクリックしてから新しいショートカットを押します。Esc でキャンセルします。"
				},
				"actions": {
					"recording": "キーを押してください",
					"reset": "リセット"
				},
				"errors": {
					"load": "ショートカットを読み込めませんでした",
					"conflict": "このショートカットは使用中です。",
					"failed": "ショートカットの更新に失敗しました",
					"requiresModifier": "Cmd、Ctrl、Alt、Super のいずれかを少なくとも 1 つ使用してください。"
				},
				"toggle-move": { "label": "移動の切り替え" },
				"toggle-resize": { "label": "サイズ変更の切り替え" },
				"toggle-ignore-mouse-event": { "label": "マウスイベント無視の切り替え" },
				"press-keys": "何かキーを押してください…"
			},
			"developer": { "sections": { "section": { "use-window-mouse": {
				"title": "ウィンドウマウス ツールを使用",
				"description": "Electronウィンドウのカーソル位置をテストします"
			} } } }
		}
	},
	"devtools": {
		"title": "開発者",
		"pages": {
			"context-flow": { "title": "コンテキストのフロー" },
			"editor": {
				"title": "AIRIエディタ",
				"description": "AIRIエディタウィンドウを開く",
				"button": "エディタを開く"
			},
			"lag-visualizer": { "title": "ラグビジュアライザー" },
			"performance-visualizer": {
				"title": "パフォーマンスビジュアライザー",
				"description": "FPS/ロングタスク/メモリーオーバーレイの切り替え",
				"controls": {
					"enable-all": {
						"label": "利用可能なすべてのメトリックを有効にする",
						"description": "このブラウザがサポートする各メトリックを有効にします。"
					},
					"start-recording": "記録開始",
					"stop-recording": "録音停止 ({seconds}s)",
					"export-last-recording": "最後の録音をエクスポート"
				},
				"metrics": {
					"frame-duration": {
						"label": "フレーム時間 (ミリ秒)",
						"description": "直近10秒間のアニメーションフレーム間隔。"
					},
					"long-task": {
						"label": "ロングタスク",
						"description": "少なくとも50ミリ秒を要するメインスレッドのタスク。",
						"unsupported": "このブラウザーは長時間のタスクタイミングを表示しません。"
					},
					"memory": {
						"label": "JS ヒープ（MB）",
						"description": "Chromiumのperformance.memory APIからのJavaScriptのヒープ使用量。",
						"unsupported": "このブラウザはJavaScriptヒープの使用状況を公開しません。"
					}
				},
				"recording": {
					"title": "前回の録音",
					"duration": "期間 {duration} ms",
					"limit": "録音は60秒後に停止します。"
				},
				"overlay": {
					"title": "生産力",
					"move": "パフォーマンスオーバーレイを移動",
					"reset-position": "オーバーレイ位置をリセット",
					"record": "ゲスト記録",
					"stop": "停止",
					"export": "最後の録音をエクスポート",
					"average": "平均"
				}
			},
			"markdown-stress": {
				"title": "Markdown ストレス",
				"description": "大量のチャットデータを含むMarkdownの解析とレンダリング負荷のテスト"
			},
			"widgets-calling": { "title": "ウィジェット呼び出し" }
		}
	},
	"screen-capture": { "permissions-prompt": {
		"title": "画面キャプチャ",
		"description": "画面またはウィンドウをキャプチャするには、画面とシステムのオーディオ録音の許可が必要です。",
		"open-preferences": "システム設定を開く",
		"dismiss": "閉じる",
		"instructions": {
			"step-1": "「システム設定」を開き、サイドバーから「プライバシーとセキュリティ」を選択します。",
			"step-2": "「画面&システム音声録音」および「システム音声録音のみ」のセクションで、AIRI用のスイッチをオンにしてください。",
			"step-2-note": "AIRIが表示されていない場合は、「+」ボタンをクリックして「アプリケーション」フォルダから「AIRI」を選択して手動で追加してください。"
		}
	} }
};
//#endregion
export { data as default };
